import { render, staticRenderFns } from "./sideIndex.vue?vue&type=template&id=14ab6ec2&scoped=true"
import script from "./sideIndex.vue?vue&type=script&lang=js"
export * from "./sideIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ab6ec2",
  null
  
)

export default component.exports